<template>
  <layout titlePage="RSVP da assessoria">
    <section class="c-rsvp-assessoria">
      <div class="container">
        <h1
          class="is-size-3 is-size-2-desktop has-text-grey-darker has-text-weight-bold"
        >
          Gerenciar convidados
        </h1>
        <p>
          O gerenciamento dos convidados e o acompanhamento das confirmações de
          presença é realizado diretamente na
          <span class="has-text-primary has-text-weight-bold"
            >plataforma da sua assessoria</span
          >.
        </p>
        <p class="columns-title">
          Na plataforma da sua assessoria você poderá:
        </p>
        <div class="columns-wrapper">
          <div class="columns is-vcentered is-mobile">
            <div class="column is-one-quarter left-column">
              <img class="img-user-list" :src="images.userList" />
            </div>
            <div class="column is-three-quarters right-column">
              <h4>Cadastrar seus convidados</h4>
              <p>
                Adicione seus convidados ou importe uma lista completa. Ao
                confirmar presença, seus convidados deverão informar os nomes
                cadastrados previamente por você.
              </p>
            </div>
          </div>
          <hr />
          <div class="columns is-vcentered is-mobile">
            <div class="column is-one-quarter left-column">
              <img class="img-list-check" :src="images.listChecks" />
            </div>
            <div class="column is-three-quarters right-column">
              <h4>Acompanhar as confirmações de presença</h4>
              <p>
                Veja quem confirmou presença no seu casamento e quem ainda não.
                Você também poderá enviar uma mensagem lembrando os convidados
                de confirmarem presença!
              </p>
            </div>
          </div>

          <div
            v-if="wedSiteGuestsInfo === true"
            class="columns is-vcentered is-mobile flex-column outter-rsvp-download-holder"
          >
            <div class="flex-column pink-bordered-column">
              <div class="custom-rsvp-download-icon-wrapper">
                <svg
                  width="35"
                  height="34"
                  viewBox="0 0 47 46"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.4151 0.817627C18.8826 0.817627 14.4519 2.13723 10.6832 4.60956C6.91462 7.08189 3.97733 10.5959 2.24282 14.7072C0.508312 18.8186 0.0544855 23.3426 0.93873 27.7072C1.82298 32.0717 4.00558 36.0808 7.21053 39.2275C10.4155 42.3742 14.4988 44.5171 18.9442 45.3853C23.3896 46.2535 27.9974 45.8079 32.1849 44.1049C36.3724 42.4019 39.9515 39.5181 42.4696 35.818C44.9877 32.1179 46.3317 27.7677 46.3317 23.3176C46.325 17.3523 43.9084 11.6332 39.6121 7.41505C35.3159 3.19692 29.4909 0.824261 23.4151 0.817627ZM23.4151 41.3176C19.7891 41.3176 16.2445 40.2619 13.2296 38.2841C10.2147 36.3062 7.86488 33.495 6.47727 30.2059C5.08966 26.9169 4.7266 23.2977 5.434 19.806C6.14139 16.3143 7.88747 13.107 10.4514 10.5897C13.0154 8.07236 16.2821 6.35803 19.8384 5.66349C23.3947 4.96896 27.0809 5.32542 30.4309 6.6878C33.7809 8.05017 36.6442 10.3573 38.6587 13.3174C40.6732 16.2774 41.7484 19.7576 41.7484 23.3176C41.7428 28.0898 39.8095 32.665 36.3725 36.0395C32.9356 39.414 28.2757 41.3122 23.4151 41.3176ZM23.4151 22.1926C22.8073 22.1926 22.2244 22.4297 21.7946 22.8516C21.3648 23.2736 21.1234 23.8459 21.1234 24.4426V31.1926C21.1234 31.7894 21.3648 32.3617 21.7946 32.7836C22.2244 33.2056 22.8073 33.4426 23.4151 33.4426C24.0229 33.4426 24.6057 33.2056 25.0355 32.7836C25.4653 32.3617 25.7067 31.7894 25.7067 31.1926V24.4426C25.7067 23.8459 25.4653 23.2736 25.0355 22.8516C24.6057 22.4297 24.0229 22.1926 23.4151 22.1926ZM23.4151 13.1926C22.8485 13.1926 22.2947 13.3576 21.8236 13.6666C21.3525 13.9757 20.9853 14.4149 20.7685 14.9288C20.5517 15.4427 20.495 16.0082 20.6055 16.5538C20.7161 17.0994 20.9889 17.6005 21.3895 17.9939C21.7901 18.3872 22.3005 18.6551 22.8562 18.7636C23.4119 18.8721 23.9879 18.8164 24.5113 18.6035C25.0347 18.3907 25.4821 18.0302 25.7969 17.5677C26.1116 17.1052 26.2796 16.5614 26.2796 16.0051C26.2796 15.2592 25.9778 14.5438 25.4406 14.0164C24.9034 13.4889 24.1748 13.1926 23.4151 13.1926Z"
                    fill="#E583A2"
                  />
                </svg>
              </div>
              <div class="custom-rsvp-download-msg-wrapper">
                <p @click="getGuestList()" class="custom-rsvp-download-msg-p">
                  Você já teve presenças respondidas no Casar.com<br />
                  <span class="rsvp-download-btn-p">Clique aqui</span> para
                  baixar a planilha
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="has-text-centered">
          <a class="button is-primary" :href="assessoriaLink" target="_blank">
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
            Gerenciar convidados
          </a>
          <p class="link-to-faq">
            Dúvidas?
            <a
              class="has-text-primary has-text-weight-bold"
              href="https://ajuda.casar.com/"
              target="_blank"
            >
              Acesse aqui a nossa FAQ =)
            </a>
          </p>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import userListImg from '@/assets/img/rsvp-assessoria/user-list-light.png'
import listChecksImg from '@/assets/img/rsvp-assessoria/list-checks-duotone.png'
import RsvpApi from '@/lib/api/Rsvp'

const APP_ENV = process.env.VUE_APP_ENV

export default {
  components: {
    layout,
  },
  metaInfo: {
    title: 'RSVP - Assessoria',
  },

  data() {
    return {
      started: false,
      images: {
        userList: userListImg,
        listChecks: listChecksImg,
      },
    }
  },

  methods: {
    getGuestList() {
      const domain = this.getUrlWedding()
      const rsvpApi = new RsvpApi(this.logonToken)
      rsvpApi.downloadGuestsList(domain).then((response) => {
        let url = ''

        APP_ENV === 'local'
          ? (url = response.data.data.replace('localstack', '172.20.0.12'))
          : (url = response.data.data)

        const fileLink = document.createElement('a')

        fileLink.href = url
        document.body.appendChild(fileLink)

        fileLink.click()
      })
    },

    getUrlWedding() {
      const url = this.wedSiteInfo.site_url

      let arrayUrl = url.split('/')

      // return if site interno
      if (arrayUrl.length > 1) {
        return arrayUrl[1]
      }

      // site with domain
      arrayUrl = url.split('.')
      return arrayUrl[0]
    },
  },

  computed: {
    assessoriaLink() {
      return (
        'https://assessoriavip.com.br/redirectLoginOrganizerByEventHash/' +
        this.$store.state.app.wedSiteInfo.parceria_id_ref
      )
    },

    wedSiteGuestsInfo() {
      const websiteData = this.$store.state.app.wedSiteInfo
      return websiteData.has_rsvp_guests
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },

    wedSiteInfo: {
      get() {
        return this.$store.state.app.wedSiteInfo
      },
    },
  },
}
</script>

<style lang="scss">
.c-rsvp-assessoria {
  .container {
    line-height: 1.2;
    text-align: center;

    @media (min-width: $tablet) {
      max-width: 810px;
    }

    h1 {
      margin-bottom: 0.3em;
    }

    .columns-title {
      font-weight: bold;
      margin: 50px auto 40px;
    }

    .columns-wrapper {
      margin: 0 auto;
      max-width: 585px;
    }

    .left-column {
      @media (min-width: $tablet) {
        width: 130px;
      }
    }

    .right-column {
      text-align: left;
      max-width: 421px;
    }

    .img-user-list {
      height: auto;
      width: 94px;
    }

    .img-list-checks {
      height: auto;
      width: 75px;
    }

    h4 {
      color: $primary;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 4px;
    }

    hr {
      margin: 30px auto 30px;
      max-width: 338px;
    }

    .button {
      margin: 50px 0 30px;
      i {
        margin-right: 10px;
      }
    }

    .outter-rsvp-download-holder {
      justify-content: center;
      margin-top: 15px;
    }

    @media (min-width: 768px) {
      .outter-rsvp-download-holder {
        width: 100% !important;
      }

      .pink-bordered-column {
        border: 2px solid #e16e92;
        border-radius: 12px;
        width: 85%;
        padding: 15px 50px 15px;
      }
    }

    @media (max-width: 767px) {
      .pink-bordered-column {
        border: 2px solid #e16e92;
        border-radius: 12px;
        width: 92%;
        padding: 15px 50px 15px;
      }
    }

    .flex-column {
      display: flex;
    }

    .flex-row-direction {
      flex-direction: row;
    }

    .custom-rsvp-download-icon-wrapper {
      display: flex !important;
      align-items: center !important;
    }

    .custom-rsvp-download-msg-wrapper {
      padding-left: 30px;
    }

    .custom-rsvp-download-msg-p {
      text-align: left;
      font-size: 15px !important;
      line-height: 22px;
    }

    .rsvp-download-btn-p {
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  padding: 3em 1em;
}
</style>
